export enum PresetValues {
  answerQuickly = 'answerQuickly',
  custom = 'custom',
}
